import JobReport from "./JobReport";
import SummaryReport from "./SummaryReport";

export default {
  JobReport,
  SummaryReport,
};
